import Registry from "./models/Registry";
import Slider from "./components/Slider";
import Accordion from "./components/Accordion";
import SliderTitolo from "./components/SliderTitolo";
import HeroImage from "./components/HeroImage";
import Slider3elementi from "./components/Slider3elementi";
import ProductImages from "./components/ProductImages";
import './components/Fadein';
import Button from './components/Button';
import MainMenu from './components/MainMenu';
import Gmultimap from "./components/Gmultimap";
import CambioBg from "./components/CambioBg";
import CtaLanguage from "./components/CtaLanguage";
import ContactsMap from "./components/ContactsMap";
import GmultimapIubenda from './components/GmultimapIubenda';
import ColorText from "./components/ColorText";
import TitleEntrance from "./components/TitleEntrance";
import ScrollSmootherPage from './components/ScrollSmootherPage';
import StickyColumn from './components/StickyColumn';
import Smoke from './components/Smoke';
import FilterFaq from './components/FilterFaq';
import FoamSteps from './components/FoamSteps';
import VideoTutorial from './components/VideoTutorial';
import DecorationsAnimation from "./components/DecorationsAnimation";
import LockerImages from "./components/LockerImages";
import ScrollTo from "./components/ScrollTo";
class App {
  constructor(context) {
    this.registry = new Registry();
    this.registerComponents();
    this.initController(context);
    this.patchIos();
    this.setvh();
  }

  initController(contextData) {
    const Context = this.registry.getContext(contextData);
    new Context(contextData);
  }

  registerComponents() {
    this.registry
      .addComponent('Slider', Slider)
      .addComponent('Accordion', Accordion)
      .addComponent('HeroImage', HeroImage)
      .addComponent('SliderTitolo', SliderTitolo)
      .addComponent('Slider3elementi', Slider3elementi)
      .addComponent('ProductImages', ProductImages)
			.addComponent('MainMenu', MainMenu)
      .addComponent('Gmultimap', Gmultimap)
      .addComponent('CambioBg', CambioBg)
      .addComponent('CtaLanguage', CtaLanguage)
			.addComponent('GmultimapIubenda', GmultimapIubenda)
      .addComponent('ContactsMap', ContactsMap)
      .addComponent('ColorText', ColorText)
			.addComponent('Button', Button)
      .addComponent('TitleEntrance', TitleEntrance)
      .addComponent('ScrollSmootherPage', ScrollSmootherPage)
      .addComponent('StickyColumn', StickyColumn)
      .addComponent('Smoke', Smoke)
			.addComponent('FilterFaq', FilterFaq)
      .addComponent('FoamSteps', FoamSteps)
      .addComponent('VideoTutorial', VideoTutorial)
      .addComponent('DecorationsAnimation', DecorationsAnimation)
      .addComponent('LockerImages', LockerImages)
      .addComponent('ScrollTo', ScrollTo)
    ;
  }

  patchIos() {
    window.addEventListener('resize', () => this.appHeight())
    this.appHeight()
  }

  appHeight() {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }

  setvh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  
}

window.AppInit = function(context) {
    new App(context);
};
